module.exports = __webpack_public_path__ + "img/bulb-verify-image.da582db7.png";